<template>
  <div class="learning_module">
    <!-- 头部 -->
    <!-- <div class="learning_module_head">
       <span class="el-icon-back" @click="$router.go(-1)"></span>
       <span>{{courseName}}</span>
       <span></span>
    </div> -->
    <!-- 内容 -->
    <div class="learning_module_content">
      <!-- 导航 -->
      <zl-navigation :leftMenuShow="leftMenuShow" @setMenuIndex="setMenuIndex" @changeShow="changeShow"
                     @handleTreeNodeClick="handleTreeNodeClick" :courseId="courseId"
                     :subjectId="subjectId"></zl-navigation>
      <!-- 菜单栏 -->
      <div :style="menuDivStyle">
        <zl-sidebar
          :courseName="courseName"
          :courseId="courseId"
          :subjectId="subjectId"
          :leftMenuShow="leftMenuShow"
          ref="zlSidebar"
          @handleTreeNodeClick="handleTreeNodeClick"
          isShow
        ></zl-sidebar>
      </div>
      <!-- 课程内容 -->
      <!-- <Split v-model="scale"> -->
      <div class="learning_module_body" :style="leftDivStyle" v-loading="zl_loading">
        <div style="flex: 1;padding: 10px 7%">
          <div v-if="!leftMenuShow" class="app_tree_title">
            <img @click="goBack" src="../../assets/image/learnmodel/back@2x.png" alt="">{{courseName}}
          </div>
          <div class="chapterHead">
                <span class="chapterName">
                    {{ catalogue.catalogName}}
                </span>
            <div style="display:flex;align-items: center;justify-content: space-between;">
              <div style="display:flex;align-items:center;margin-right:30px;">
                <div class="btn1" @click="prev(1)">上一节</div>
                <div class="title">{{prevTitle}}</div>
              </div>
              <div style="display:flex;align-items:center;">
                <div class="title">{{nextTitle}}</div>
                <div class="btn2" @click="prev(-1)">下一节</div>
              </div>
            </div>
          </div>
          <div style="display:flex;height:calc(100% - 100px);justify-content: space-between;">
            <status_1_content
              :answerList="answerList"
              @submitAnswer="submitAnswer"
              @handleGoStudy="handleGoStudy"
              @judgeIsDown="judgeIsDown"
              @addEventObj="addEventObj"
              isShow
              class="status_1_content"
              v-model="chapter"
            ></status_1_content>
            <imageTextIndexes v-if="chapter.type == 6&&!openRight" v-model="chapter"></imageTextIndexes>
          </div>

        </div>

      </div>
      <!-- 拖拽线 -->
      <div class="learning_module_line"
           @mousedown.stop="lineMove($event)"
           v-if="openRight"
      ></div>
      <!-- 操作界面 -->
      <div :style="rightDivStyle"
           :class="menuIndex == 3||menuIndex == 2?'learning_module_operation backF':'learning_module_operation'"
           v-loading="rightLoading">
        <div class="masking" :style="rightMaskStyle"></div>
        <div style="background-color: #292A2B;padding: 0 15px;line-height: 30px;border-bottom: solid 1px #676B79">
          <el-button size="mini" type="text" @click="changeOpenRight">关 闭</el-button>
        </div>
        <!-- <note style="height: calc(100% - 32px);width: 100%"></note> -->
        <div style="height: calc(100% - 32px);width: 100%" v-if="openRight">
          <code-compiler
            v-if="showRightType === 0"
            ref="taskCode"
            task
            :refresh="refresh"
            v-model="taskData"

          ></code-compiler>
          <iframe
            v-else-if="showRightType === 2 || showRightType === 1"
            ref="iframe"
            height="100%"
            width="100%"
            :src="iframeAddress"
            frameborder="0"
          ></iframe>
          <discuss v-if="menuIndex==2" :isTurn="false" :CataId="this.courseId" :Cid="this.classId"
                   :Cname="this.className"></discuss>
          <note v-if="menuIndex==3" :isTurn="false" :CataId="this.courseId"></note>
        </div>
      </div>
      <!-- </Split> -->
    </div>
  </div>
</template>

<script>
  /**
   *    新-学习模块 create by wjl
   *    2021.7.28
   */
  import zlNavigation from './components/zl-navigation'
  import zlSidebar from "../component/zl-sidebar-show"; // 目录树
  import status_1_content from "../component/zlItCourseEdit_show_status_1_content";
  import imageTextIndexes from "./components/status_1_content_Indexes";
  import codeCompiler from "../component/code_compiler";
  import * as api from "../../api/courseApi"; // 内容展示
  // import note from '@/components/views/studyCenter/switch/note/note.vue'  //笔记
  import note from "@/components/subcomponent/note/note";
  import discuss from "@/components/subcomponent/discuss/discuss";//讨论
  import qs from "qs";
  import {isLinuxLabOS} from "@/utils/utils";

  export default {
    name: "learning_module",
    data() {
      return {
        courseId: sessionStorage.getItem('courseId'),
        classId: sessionStorage.getItem('classId'),
        className: sessionStorage.getItem('className'),
        subjectId: sessionStorage.getItem('subjectId'),
        questionIdList: [],
        courseName: this.$route.query.courseName,
        subjectName: this.$route.query.subjectName,
        type: this.$route.query.type,  //课程类型 ，2单项 3综合
        courseIcon: {
          1: {
            image: "tp-2@2x.png",
            alt: "图片",
          },
          3: {
            image: "sc-2@2x.png",
            alt: "实操题",
          },
          4: {
            image: "sp-2@2x.png",
            alt: "视频",
          },
          5: {
            image: "ceyan-2@2x.png",
            alt: "测验",
          },
          6: {
            image: "zh-2@2x.png",
            alt: "图文",
          },
          7: {
            image: "tp-2@2x.png",
            alt: "图片",
          },
          8: {
            image: "wd-2@2x.png",
            alt: "文档",
          },
          9: {
            image: "yp-2@2x.png",
            alt: "音频",
          },
          10: {
            image: "sp-2@2x.png",
            alt: "视频",
          },
        },
        addType: 0, // 1素材，2作业，3习题，5测验，6图文，7图片，8文档, 9音频，10视频
        chapter: {},
        catalogue: {},
        zl_loading: false,
        rightLoading: false,
        openRight: false,

        task: {},  //作业
        taskData: '',
        // 2021.7.30
        iframeAddress: 'http://192.168.0.6/lab/',
        leftDivStyle: {},
        rightDivStyle: {},
        menuDivStyle: {height: '100%', width: '0px', transition: 'all 0.3s ease'},
        rightMaskStyle: {},
        leftMenuShow: false,
        eventList: [],//题目请求的event对象的集合
        answerList: [],//单选题多选题的数据状态集合
        showRightType: 0, //0代码块 1 编辑器 2 终端
        // wjl 2021.8.10
        refresh: false, // 刷新
        prevTitle: '',//上一章标题
        nextTitle: '',//下一章标题
        menuIndex: 1,//菜单
      }
    },
    components: {
      zlNavigation,
      status_1_content,
      codeCompiler,
      zlSidebar,
      imageTextIndexes,
      note,
      discuss
    },
    methods: {
      goBack() {
        this.$router.go(-1)
      },
      addEventObj(obj) {
        this.eventList.push(obj)
      },
      prev(num) {
        let arr = this.$refs.zlSidebar.prev()
        let obj = JSON.parse(sessionStorage.getItem('handleTreeNodeClick'))
        let index = 0
        arr.forEach((val, ind) => {
          if (val.id == obj.id) {
            index = ind
          }
        });
        // console.log(num,index,arr)
        if (num == 1) {
          if (index > 0 && index < arr.length) {
            this.$refs.zlSidebar.defualtOne(arr[index - 1])
          }
        } else if (num == -1) {
          if (index >= 0 && index < arr.length - 1) {
            this.$refs.zlSidebar.defualtOne(arr[index + 1])
          }
        } else {
        }
      },
      handleTreeNodeClick(treeData) {
        // console.log(treeData)
        // if (treeData.catalogParentId == 0) return;
        this.$store.commit('changeNote', treeData);
        // console.log(treeData)
        if (
          !treeData.children ||
          (treeData.children && !treeData.children.length)
        ) {
          this.zl_loading = true;
          this.catalogue = treeData;
          this.getPrevNextTitle(treeData)
          // console.log('---2---', item);
          api
            .handleNodeClick(this.courseId, treeData.id)
            .then((res) => {
              if (res.code == 0) {
                if (res.data && res.data.length) {
                  this.chapter = res.data[0];
                  this.questionIdList = JSON.parse(this.chapter.imageText).map((val, ind) => {
                    try {
                      if (val.valueObj.questionContent.internalTypeId == 1 || val.valueObj.questionContent.internalTypeId == 2 || val.valueObj.questionContent.internalTypeId == 3) {
                        return val.valueObj.questionContent.id
                      } else {
                        return ''
                      }
                    } catch (err) {
                      return ''
                    }
                  }).filter((val, ind) => {
                    return val != ''
                  })
                  // console.log(this.questionIdList)
                  this.QueryAnswer()
                  this.addType = this.chapter.type;
                }
              } else {
                this.$message.warning("暂无数据");
              }
            })
            .finally(() => {
              this.changeOpenRight();
              this.zl_loading = false;
            })
            .catch((error) => {
              this.$messageError(error);
            });
        }
      },
      getPrevNextTitle(treeData) {
        this.$refs.zlSidebar.prev().forEach((val, ind) => {
          if (val.id == treeData.id) {
            if (ind == 0) {
              this.prevTitle = ''
              this.nextTitle = this.$refs.zlSidebar.prev()[ind + 1].catalogName
            } else if (ind == (this.$refs.zlSidebar.prev().length - 1)) {
              this.prevTitle = this.$refs.zlSidebar.prev()[ind - 1].catalogName
              this.nextTitle = ''
            } else {
              this.prevTitle = this.$refs.zlSidebar.prev()[ind - 1].catalogName
              this.nextTitle = this.$refs.zlSidebar.prev()[ind + 1].catalogName
            }
          }
        })
      },
      QueryAnswer() {
        api.QueryAnswer({
          courseId: this.courseId,
          classId: this.classId,
          questionIds: this.questionIdList
        }).then(res => {
          if (res.code == 0) {
            if (res.data[0] && res.data[0].id) {
              this.answerList = res.data
            } else {
              this.answerList = []
            }
          }
        })
      },
      changeShow(bol) {
        // console.log(bol)
        this.showRightType = ''
        this.menuDivStyle = {
          height: '100%',
          width: bol ? '300px' : '0px',
          opacity: bol ? '1' : '0',
          transition: 'all 0.3s ease'
        }
        this.leftMenuShow = bol
        if (this.menuIndex != 1) {
          if (bol == false) {
            this.handleGoStudy('showMenu')
          } else {
            if (this.openRight) {
              this.rightDivStyle = {width: `0px`}
              this.leftDivStyle = {width: `100%`}
            }
            this.openRight = false
          }

        } else {
          if (this.openRight) {
            this.rightDivStyle = {width: `0px`}
            this.leftDivStyle = {width: `100%`}
          }
          this.openRight = false
        }

      },
      setMenuIndex(num) {
        console.log(num)
        this.menuIndex = num
      },
      async handleGoStudy(data) {
        // console.log(data,this.openRight)
        this.taskData = '';

        if (typeof (data) == 'string') {
          if (!this.openRight) {
            this.rightDivStyle = {width: `calc(50% - 55px)`}
          }
          this.openRight = true;
          return
        }
        console.log('--data--', data);
        // 当在创建这篇图文时，预制了代码文件。这里需要直接打开编辑器
        if (data.extendOption.allCode) {
          this.showRightType = 1
          this.openCompilerOS();
        } else if (data.type == 11) {
          this.showRightType = 0
          this.taskData = data.value
          /* 刷新代码内容 */
          this.refresh = !this.refresh;
          /* 样式报错，异步初始化codeCompiler */
          if (this.$refs.taskCode) {
            let timer = setTimeout(() => {
              this.$nextTick(() => {
                this.$refs.taskCode.coder.refresh();
                clearTimeout(timer)
              })
            }, 500)
          }

        } else {
          this.task = data;
          let arr = this.eventList.filter((val, ind) => {
            return val.questionId == data.value
          })
          let list = await this.getparams(data.value, arr[0].eventId)
          if (list.length <= 0) {
            return
          } else {

          }
          let checkObj = list.filter((val, ind) => {
            return val.key == 'platform'
          })[0];
          if (checkObj.value == 'codeBlockOS') {//代码块
            this.showRightType = 0
            this.taskData = '';
            /* 刷新代码内容 */
            this.refresh = !this.refresh;
            /* 样式报错，异步初始化codeCompiler */
            if (this.$refs.taskCode) {
              let timer = setTimeout(() => {
                this.$nextTick(() => {
                  this.$refs.taskCode.coder.refresh();
                  clearTimeout(timer)
                })
              }, 500)
            }
          } else if (checkObj.value === "jupyterNoteBook") {
            //  编辑器1
            this.showRightType = 1;
            this.openCompilerOS();
          } else if (checkObj.value === "jupyterTerminals") {
            //   终端
            this.showRightType = 1;
            this.openCompilerOS('jupyterTerminals');
          } else if (isLinuxLabOS(checkObj.value)) {
            //  编译器2
            this.showRightType = 2;
            this.iframeAddress =
              "https://testnovnc.cailian.net/vnc_lite.html";
            // this.iframeAddress =
            //   "http://192.168.0.7:6080/vnc_lite.html?host=192.168.0.7&port=6080&path=websockify/?token=7";
          } else {
            this.$messageWarning('无效的跳转')
          }
        }
        if (!this.openRight) {
          this.rightDivStyle = {width: `calc(50% - 55px)`}
        }
        this.openRight = true;
      },
      // 打开编辑器
      openCompilerOS(to) {
        if (localStorage.getItem('Authorization') && sessionStorage.getItem('userId')) {
          let params = {
            token: localStorage.getItem('Authorization'),
            userId: sessionStorage.getItem('userId'),
            sourceId: '',
            questionId: '',
            templeteCode: '',
            catalogId: this.catalogue.id,
            roleCodes: '',
          }
          if (to === 'jupyterTerminals') {
            params['kernelType'] = 'terminals'
          }
          this.iframeAddress = process.env.VUE_APP_COS + '?' + qs.stringify(params)
        } else {
          this.$messageError('账户信息未获取成功');
        }
      },

      getparams(resourceId, id) {//根据资源ID 获取动态参数列表
        let list = [];
        return new Promise((resolve) => {
          api.getparams({resourceId: resourceId, id: id}).then(rs => {
            if (rs.code === "0") {
              if (rs.data.length > 0) {
                rs.data.map((item) => {
                  let obj = {
                    key: item.param,
                    value: item.value
                  }
                  list.push(obj);
                })
                resolve(list);
              }
              resolve(list);
            } else {
              this.$messageError(rs.msg);
            }
          })
            .catch(function (error) {
              console.log(error);
              this.$messageError("后台接口错误！");
            });
        })
      },
      changeOpenRight() {
        if (this.openRight) {
          this.rightDivStyle = {width: `0px`}
          this.leftDivStyle = {width: `100%`}
        }
        this.openRight = false;
      },
      /** 轴挪动 */
      lineMove(e) {
        let that = this;
        document.onmousemove = function (ev) {
          window.event.preventDefault() //
          window.event.cancelBubble = true //IE
          var l = ev.pageX;
          if (l < 460) {
            return
          }
          if (this.leftMenuShow) {
            that.leftDivStyle = {width: `calc(${l}px - 380px)`}
          } else {
            that.leftDivStyle = {width: `calc(${l}px - 80px)`}
          }

          that.rightDivStyle = {width: `calc(100% - ${l}px)`, transition: `all 0s ease!important`}
          that.rightMaskStyle = {zIndex: 99}
        }
        document.onmouseup = function () {
          document.onmousemove = null
          that.rightMaskStyle = {zIndex: -1}
        }

      },
      // 提交作答记录
      submitAnswer(val) {
        console.log(val)
        // return
        let param = {
          "courseId": val.answerDetail.courseId,
          "classId": val.answerDetail.classId,
          "questionId": val.answerDetail.questionId,
          "questionType": val.internalTypeId, //** 试题类型 1:单选题,2:多选题,3:判断题,4:问答题,6:组合题,9:实操题 */
          "version": Number(val.answerDetail.version) + 1,
          "userAnswer": val.answerDetail.userAnswer,
          "useTime": 0,
          "questionStatus": 0,
          "stepId": 0,
          "resourceId": val.answerDetail.questionId
        }
        api.SaveRecord(param).then(res => {
          console.log(res)
          if (res.code == 0) {
            this.QueryAnswer()
          }
        })

      },
      //判断当前页是否浏览完成
      judgeIsDown() {

      }
    },
    mounted() {

    }
  }
</script>

<style scoped lang="scss">
  .learning_module {
    height: 100%;
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .learning_module_head {
      height: 45px;
      line-height: 45px;
      border-bottom: 1px solid #979797;
      padding: 0 15px;

      span {
        font-size: 20px;
        font-weight: 600;
        cursor: pointer;
      }
    }

    .learning_module_content {
      flex: 1;
      display: flex;
      overflow: hidden;
      justify-content: center;
      // background-color: #EAEAEA;
      .learning_module_body {
        width: 100%;
        overflow: hidden;
        display: flex;
        background-color: #ffffff;
        position: relative;

        .app_tree_title {
          height: 20px;
          line-height: 20px;
          text-indent: 20px;
          font-size: 13px;
          color: #333333;
          display: flex;
          align-items: center;

          img {
            width: 25px;
            height: 25px;
            margin-right: 8px;
          }
        }

        .chapterHead {
          display: flex;
          justify-content: space-between;
          align-items: center;
          line-height: 50px;
          height: 60px;
          box-sizing: border-box;
          border-bottom: 1px solid #42414D;

          .title {
            font-size: 10px;
            color: #999999;
            white-space: nowrap;
          }

          .chapterName {
            font-size: 22px;
            font-weight: 600;
          }

          .btn1 {
            width: 73px;
            height: 28px;
            // background: linear-gradient(90deg, #007CFF 0%, #00C5FF 100%);
            border-radius: 2px;
            line-height: 28px;
            text-align: center;
            color: #007CED;
            font-size: 13px;
            cursor: pointer;
          }

          .btn2 {
            width: 73px;
            height: 28px;
            border-radius: 2px;
            // border: 1px solid #007DFF;
            line-height: 28px;
            text-align: center;
            color: #007CED;
            font-size: 13px;
            box-sizing: border-box;
            cursor: pointer;
          }
        }

        .status_1_content {
          height: calc(100% - 55px);
          max-width: 900px;
          flex: 1;
        }
      }

      .learning_module_line {
        width: 8px;
        height: 100%;
        background: #bbb;
        cursor: ew-resize;
      }

      .learning_module_operation {
        width: 0px;
        overflow: hidden;
        transition: all 0.3s ease;
        /*background-color: #292A2B;*/
        position: relative;

        .console {
          width: 100%;
          height: 50%;
          background: #eee;
          padding: 30px;
          box-sizing: border-box;
          line-height: 40px;
          white-space: pre-line;
        }

        .code_wrap {
          height: calc(100% - 32px);
          overflow-y: scroll;

          /deep/ img {
            max-width: 100%;
          }
        }
      }

      .masking {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: -1;
      }

      .openRight {
        width: calc(50% - 55px);
      }
    }
  }

  .backF {
    background: #fff !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/new_learning_module/learning_module.vue